import React from "react";
import { Link } from 'react-router-dom';
import { Form, Input, Button, Card, Alert, message } from 'antd';
import { UserOutlined } from '@ant-design/icons';

import { connect } from 'react-redux';
import { forgotPassword } from "../actions/userActions";

import logo from '../images/logo_large.png'

class ForgotPassword extends React.Component {

  state = {
    redirectToReferrer: false
  }

  handleSubmit = values => {
    const { email } = values;
    this.props.dispatch(forgotPassword(email));
  };

  componentDidUpdate = (prevProps) => {
    if (prevProps.success !== this.props.success) {
      if (this.props.success) {
        message.success('Your request has been received and will be processed soon');
        this.props.history.push('/login')
      }
    }
  }

  render() {
    const { error, loading } = this.props;

    return (
      <div className="login-container">
        <Card title="Recover Password" style={{ width: 300 }}>
          {error ? <Alert message="Invalid email or password" type="error" style={{ marginBottom: '1em' }} /> : ''}
          <Form layout='vertical' onFinish={this.handleSubmit}>
            <img src={logo} style={{ marginBottom: '2em' }} alt="Umbrella" />
            <Form.Item name="email" rules={[{ required: true, message: 'Please enter your username' }]}>
              <Input
                prefix={<UserOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                placeholder="Email"
              />
            </Form.Item>
            <Button block type="primary" htmlType="submit" className="login-form-button" disabled={loading}>
              Email instructions
            </Button>
            <div style={{ marginTop: '1rem' }}></div>
            <div>
              <Link style={{ float: 'left' }} to="/login">
                Login
              </Link>
            </div>
          </Form>
        </Card>
      </div>
    );
  }
}


const mapStateToProps = state => ({
  user: state.auth.user,
  loading: state.auth.loading,
  error: state.auth.error,
  success: state.auth.success
});
export default connect(mapStateToProps)(ForgotPassword);